import { createSelector } from '@reduxjs/toolkit';
import { fetchStatuses } from '../../../constants/fetchStatuses';
import { ReducerState } from '../../store.types';

export const reconciliationSelector = ({ reconciliation }: ReducerState) => reconciliation;

export const reconciliationRunsLoadingSelector = createSelector(
  reconciliationSelector,
  ({ fetchReconciliationRunsStatus }) => fetchReconciliationRunsStatus === fetchStatuses.pending,
);

export const reconciliationRunDetailLoadingSelector = createSelector(
  reconciliationSelector,
  ({ fetchRunDetailStatus }) => fetchRunDetailStatus === fetchStatuses.pending,
);

export const reconciliationRunExportLoadingSelector = createSelector(
  reconciliationSelector,
  ({ exportReconciliationRunStatus }) => exportReconciliationRunStatus === fetchStatuses.pending,
);

export const reconciliationRunItemDetailLoadingSelector = createSelector(
  reconciliationSelector,
  ({ fetchReconciliationItemDetailStatus }) => fetchReconciliationItemDetailStatus === fetchStatuses.pending,
);
